<template>
  <main-layout>
    <div class="cards" v-for="item in getCourseData">
      <div class="card" style="width: 100%;">
        <div class="card-img-top" style="background: linear-gradient(-90deg, #26AAb2, #53D1AF); padding:4rem; color:white; text-align:center;">
          <h2>{{ item.name }}</h2>
        </div>
        <div class="card-body" style="padding:1.25rem 1.5rem 2.25rem 1.5rem">
          <h4 class="card-title">by {{ item.author }}</h4>
          <div style="color:rgba(0,0,0,.2); font-weight:bold">
            <span><i class="fa fa-clock-o fa-lg" aria-hidden="true"></i> ~{{ item.lCTime }} Min</span>
            <!--<span style="margin-left: 4px;"><i class="fa fa-users" aria-hidden="true"></i> 6 User</span>-->
            <span style="color:#f2c300"><span style="margin-top: -4px; margin-right: -2px;" class="coinicon3"></span> {{item.assignmentPoints}} LPs</span>
          </div>
          <p class="card-text">{{ item.description }}</p>
            <button class="btn btn-outline-primary btn-lg btn-block" @click="goToCourse(item.id)">Learn more</button>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import { store } from '../store/store.js'
import MainLayout from './MainLayout.vue'


export default {
    data() {
        return {
        
        }
    },
    components: {
        MainLayout
    },
  computed: {
      getCourseData() {
        return this.$store.getters.getLCData
      },
      getCurrentCourse() {
        return this.$store.getters.currentCourse
      }
  },
    methods: {
        goToCourse(courseId) {
            //store.dispatch('setCourse', courseId);
            this.$router.push({path: '/course/' + courseId + '/introduction/'})
        },
        setCourse(courseId){
            store.dispatch('setCourse', courseId)
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/CourseSelection.vue